import React, { Component } from "react";
import Hero from "../components/Hero";
import { ContentWrapper, Flex, Box, IndexTitle, IndexTitleBig } from "../components/Layout";
import { css } from "react-emotion";
import colors from "../utils/colors.js";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonRow
} from "../components/Buttons";
import Card from "../components/Cards";
import feather from "../utils/feather.js";
import imageBig from "../assets/images/business-header-big.jpg";
import imageSmall from "../assets/images/business-header-small.jpg";
import Link from "gatsby-link";
import LogoBar from "../components/LogoBar";
import Typist from "react-typist";

class Index extends Component {
  render() {
    const {
      header,
      social_links,
      mission_statement
    } = this.props.data.allBusinessJson.edges[0].node;
    const { edges: projects } = this.props.data.allMarkdownRemark;
    const latestProjects = projects.slice(-3);
    const cursor_props = {
      show: false,
      blink: true,
      element: "|",
      hideWhenDone: false,
      hideWhenDoneDelay: 1000
    };
    // const { edges: client} = this.props.data.allPcsClientsJson;
    return <div>
        <Hero imageBig={imageBig} imageSmall={imageSmall}>
          <Box color="white" p={[3, 3, 4]} align="left">
            <h3>{header.headline}</h3>
            <Typist cursor={cursor_props}>
              <h1>
                {header.title}
                <Typist.Backspace count={24} delay={220} />
                CS installs Access Control
                <Typist.Backspace count={14} delay={220} />
                CCTV & Security
                <Typist.Backspace count={15} delay={220} />
                Fiber Optics
                <Typist.Backspace count={12} delay={220} />
                Data Centers
                <Typist.Backspace count={12} delay={220} />
                Cat6 + Cat5 Cabling
                <Typist.Backspace count={19} delay={220} />
                DAS + BDA Systems
                <Typist.Backspace count={26} delay={220} />
                In Business 25+ Years
              </h1>
            </Typist>
            <ContentWrapper>
              <p>{header.subline}</p>
            </ContentWrapper>
          </Box>
        </Hero>
        <LogoBar />
        <Box bg="white" p={[3, 3, 4]} align="left">
          <IndexTitleBig fontSize={[6, 7, 8]}>Low Voltage & Fiber Optic Experts</IndexTitleBig>
          <p>{mission_statement}</p>
          <ButtonRow>
            <Link to="/contact">
              <p>
                <h4>Get Your FREE Quote Now!</h4>
              </p>
              <PrimaryButton>Contact Us Now!</PrimaryButton>
            </Link>
          </ButtonRow>
        </Box>
        <Box bg="white" p={[3, 3, 4]} align="left">
          <IndexTitle fontSize={[6, 7, 8]}>Services</IndexTitle>
          <Flex wrap={["wrap", "wrap", "nowrap"]} justify="space-between">
            <Box color="white" width={[1, 1, 1 / 3.3]}>
              <Card inverted>
                <div>{feather("phone-call", ["50", "50"])}</div>
                <div>
                  <h2>DAS in-Building Wireless</h2>
                  <p>
                    Get a <strong>DAS</strong>(Distributed Antenna System) quote from us today, and take the first step to improving your indoor wireless service. We've got you covered from start to finish. No project is to big or to small for our certified installers. We design, install and maintain customized Fiber-Based Distributed Antenna Systems for our customers nationwide.
                  </p>
                </div>
              </Card>
            </Box>
            <Box color="white" width={[1, 1, 1 / 3.3]}>
              <Card inverted>
                <div>{feather("alert-triangle", ["50", "50"])}</div>
                <div>
                  <h2>Fire & Life Safety Systems</h2>
                  <p>
                    We offer full spectrum fire alarm systems. We design,
                    install and maintain to both local and national fire
                    codes. We also offer full spectrum healthcare systems
                    such as nurse call, patient assistance and emergency
                    call systems for hospitals, living facilities and
                    private residencies. All systems are maintained to be
                    100% NFPA 101 compliant.
                  </p>
                </div>
              </Card>
            </Box>
            <Box color="white" width={[1, 1, 1 / 3.3]}>
              <Card inverted>
                <div>{feather("server", ["50", "50"])}</div>
                <div>
                  <h2>Data Centers</h2>
                  <p>
                    <p>
                      PCS's network designs are systems are tested,
                      validated, and secure. Data security and risk
                      reduction maximize your return on investment, we will
                      help you get there. Data center installation requires
                      years of experience to master our level of expertise.
                      Our experienced technicians will handle installation,
                      repair, and maintenance, while our dedicated engineers
                      help with design.
                    </p>
                  </p>
                </div>
              </Card>
            </Box>
          </Flex>
          <Flex wrap={["wrap", "wrap", "nowrap"]} justify="space-between">
            <Box color="white" width={[1, 1, 1 / 3.3]}>
              <Card inverted>
                <div>{feather("video", ["50", "50"])}</div>
                <div>
                  <h2>CCTV and Security</h2>
                  <p>
                    We provide our customers with the most advanced
                    professional-grade security products at the best prices
                    on the market. Our team is at the forefront of the
                    security industry and is here to provide customer
                    support and technical details regarding our current
                    product offerings: security alarm systems, monitoring,
                    and surveillance CCTV systems plus networking. Stay
                    secure with Prefered Cabling Systems.
                  </p>
                </div>
              </Card>
            </Box>
            <Box color="white" width={[1, 1, 1 / 3.3]}>
              <Card inverted>
                <div>{feather("wifi", ["50", "50"])}</div>
                <div>
                  <h2>Bi-Directional Amplifiers (BDA)</h2>
                  <p>
                    Bi-Directional amplifiers (BDAs) boost signals so first
                    responders (fire, police, other government personal) can
                    communicate effectively in case of an emergency.
                    Jurisdications across the US are requring by law that
                    all building have a BDA system. That includes condos,
                    commercial, retail, medical, mixed-use, and stadiums.
                    South Florida already requires BDA systems for all hi
                    rise condos.
                  </p>
                </div>
              </Card>
            </Box>
            <Box color="white" width={[1, 1, 1 / 3.3]}>
              <Card inverted>
                <div>{feather("unlock", ["50", "50"])}</div>
                <div>
                  <h2>Access Control</h2>
                  <p>
                    Access Control provides the security businesses and
                    people need at their offices and homes. PCS sets you up
                    with a system that allows full control over vechile
                    entry, door entry, down to indivdual room access. Entry
                    gates, card readers, keypads, telephone access control,
                    biometric readers, PCS installs them all and more.
                    Access Control provides additional security and access
                    to emergency support.
                  </p>
                </div>
              </Card>
            </Box>
          </Flex>
        </Box>
        <Box color="white" bg={colors.black} p={[3, 3, 4]} align="left">
          <IndexTitle fontSize={[6, 7, 8]}>Recent Projects</IndexTitle>
          <Flex wrap={["wrap", "wrap", "nowrap"]} justify="space-between">
            {latestProjects.map(({ node: project }, index) => {
              return <Box key={index} color={colors.black} width={[1, 1, 1 / 3.3]}>
                  <Card>
                    <h2>{project.frontmatter.title}</h2>
                    <p>{project.frontmatter.description}</p>
                    <Link to={project.fields.slug}>
                      <PrimaryButton>Read More</PrimaryButton>
                    </Link>
                  </Card>
                </Box>;
            })}
          </Flex>
        </Box>
        <Box bg="white" p={[3, 3, 4]} align="left">
          <IndexTitle fontSize={[6, 7, 8]}>Contact Us</IndexTitle>
          <p>
            PCS designs, installs, and services your data network. From conception to execution we'll be there every step of the way. We have decades of expertise designing some of the biggest and most secure locations in the US. PCS wants to help you on your next project. Contact us at <strong
            >
              877-307-8131
            </strong> or send us an email to discuss how we can help with your low voltage and data needs.
          </p>
          <Link to="/about"><p>Learn more about PCS</p></Link>
          <p>
            <strong>
              <a href={`mailto:${social_links.email}`}>
                {social_links.email}
              </a>
            </strong>
          </p>
        </Box>
      </div>;
  }
}

export default Index;

export const pageQuery = graphql`
  query IndexQuery {
    allBusinessJson {
      edges {
        node {
          social_links {
            email
            linkedin
            facebook
            phone
          }
          header {
            title
            headline
            subline
          }
          mission_statement
        }
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { category: { eq: "project" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            category
            description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js